export const AVAILABLE_STATES = [
    "CREATED",
    "RUNNING",
    "SUBMITTED",
    "TERMINATED",
    "SUCCESSFUL",
    "FAILED",
    "ABORTED"
]
